import { tv } from "@/utils/tv.config";
import { VariantProps } from "tailwind-variants";

export const containerClasses = tv({
  base: ["Container__root container xs:px-6 px-4 box-border block"],
  variants: {
    maxWidth: {
      xs: "max-w-screen-xs",
      sm: "max-w-screen-sm",
      md: "max-w-screen-md",
      lg: "max-w-screen-lg",
      xl: "max-w-screen-xl",
    },
    disableGutters: {
      true: ["!px-0"],
    },
  },
  defaultVariants: {
    maxWidth: "xl",
  },
});

export type ContainerVariants = VariantProps<typeof containerClasses>;
